import React, { Fragment, MouseEvent } from 'react';
import { Profile } from '@icons/common/Profile';

interface SignInButtonProps {
  selected: boolean;
  onClick: (e: MouseEvent<HTMLButtonElement>) => void;
  title: string;
}

export const SignInButton = ({ selected, onClick, title }: SignInButtonProps) => {
  const classes = selected ? 'c-header-main-menu-item active' : 'c-header-main-menu-item';
  return (
    <button onClick={onClick} className={`${classes} sign-in-button`} >
      <i className='svg-icon pr-8 icon-sign-in'>
        <Profile />
      </i>
      {title}
    </button>
  );
};
